/**
 * Extrae StudyInstanceUID de una URL R2 típica:
 * .../{tenant}/{StudyInstanceUID}/manifest.json?...
 * @param {string|null|undefined} manifestUrl
 * @returns {string}
 */
export function studyUidFromManifestUrl(manifestUrl) {
  const raw = manifestUrl != null ? String(manifestUrl).trim() : ''
  if (!raw) return ''
  try {
    const u = new URL(raw)
    const parts = u.pathname.split('/').filter(Boolean)
    for (let i = parts.length - 1; i >= 0; i--) {
      const seg = decodeURIComponent(parts[i] || '')
      if (/^manifest\.json$/i.test(seg) && i > 0) {
        const prev = decodeURIComponent(parts[i - 1] || '')
        if (looksLikeStudyUid(prev)) return prev
      }
      if (looksLikeStudyUid(seg)) return seg
    }
  } catch (e) {
    /* ignore */
  }
  return ''
}

function looksLikeStudyUid(s) {
  if (!s || s.length < 10) return false
  // DICOM UID: dígitos y puntos; suele empezar con 1.
  return /^1\.\d[\d.]+$/.test(s)
}
